export const USER_RESTRICTIONS = {
  add_cash: 'add_cash',
  investing: 'investing',
  withdraw: 'withdraw',
};
